import firebase from "../../../services/firebase/config";
const getXeroContacts = firebase.functions().httpsCallable('getXeroContacts');
const updateXeroContact = firebase.functions().httpsCallable('updateXeroContact');

const getContactList = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data = {} } = await getXeroContacts() || {};

      if (data.Status === 'OK') {
        console.log('contacts', data.Contacts)
        resolve([...data?.Contacts]);
      }
      else {
        reject(data);
      }

    }
    catch (error) {
      reject(error);
    }
  })
}

const defaultAccountNumber = ({ id }) => id?.slice(0, 15).toUpperCase().trim();

const updateContactAccountNumber = ({ contact, accountNumber }) => {
  return new Promise(async (resolve, reject) => {
    try {

      await updateXeroContact({
        ContactID: contact.ContactID,
        AccountNumber: accountNumber
      });

      resolve(true);
    }
    catch (error) {
      reject(error);
    }
  })

}

const createOrganizationLink = ({ db, organization, contact }) => {
  return new Promise(async (resolve, reject) => {
    try {
      const accountNumber = defaultAccountNumber(organization);

      await db.update({
        path: `organizations/${organization.id}`,
        payload: {
          xeroContactId: contact.ContactID
        }
      });

      // this isn't critical but provides a useful cross-reference between the two systems (Ticit & XERO)
      // TODO: create a GCF to update the Contact with the account number 
      await updateContactAccountNumber({
        contact,
        accountNumber
      });

      resolve({
        organization: { ...organization, xeroAccountId: contact.ContactID },
        contact: { ...contact, AccountNumber: accountNumber }
      });
    }
    catch (error) {
      reject(error);
    }
  })
}

const removeOrganizationLink = ({ db, organization, contact }) => {
  return new Promise(async (resolve, reject) => {
    try {

      await db.update({
        path: `organizations/${organization.id}`,
        payload: {
          xeroContactId: ''
        }
      });

      // this isn't critical but provides a useful cross-reference between the two systems (Ticit & XERO)
      // TODO: create a GCF to update the Contact with the account number 
      await updateContactAccountNumber({
        contact,
        accountNumber: ''
      });

      resolve({
        organization: { ...organization, xeroAccountId: contact.ContactID },
        contact: { ...contact, AccountNumber: '' }
      });
    }
    catch (error) {
      reject(error);
    }
  })
}

const createMemberLink = ({ db, member, contact }) => {
  console.log('createMemberLink', member, contact);

  return new Promise(async (resolve, reject) => {
    try {
      const accountNumber = defaultAccountNumber(member);

      await db.update({
        path: `users/${member.uid}`,
        payload: {
          xeroContactId: contact.ContactID
        }
      });

      // this isn't critical but provides a useful cross-reference between the two systems (Ticit & XERO)
      // TODO: create a GCF to update the Contact with the account number 
      await updateContactAccountNumber({
        contact,
        accountNumber
      });

      resolve({
        member: { ...member, xeroContactId: contact.ContactID },
        contact: { ...contact, AccountNumber: accountNumber }
      });
    }
    catch (error) {
      reject(error);
    }
  })
}

const removeMemberLink = ({ db, member, contact }) => {

  return new Promise(async (resolve, reject) => {
    try {
      const accountNumber = '';

      await db.update({
        path: `users/${member.uid}`,
        payload: {
          xeroContactId: ''
        }
      });

      // this isn't critical but provides a useful cross-reference between the two systems (Ticit & XERO)
      // TODO: create a GCF to update the Contact with the account number 
      await updateContactAccountNumber({
        contact,
        accountNumber
      });

      resolve({
        member: { ...member, xeroContactId: contact.ContactID },
        contact: { ...contact, AccountNumber: accountNumber }
      });
    }
    catch (error) {
      reject(error);
    }
  })
}

export {
  createMemberLink,
  createOrganizationLink,
  getContactList,
  defaultAccountNumber,
  removeOrganizationLink,
  removeMemberLink
}